import { OpenAPISchema } from './OpenAPISchema';
import { type NoRefParam, type SchemaObjectWithName } from './types';

export const ParametersSection = ({
  title,
  params
}: {
  title?: string;
  params?: Array<NoRefParam>;
}) => {
  if (!params || params.length === 0) {
    return null;
  }
  return (
    <div className="flex flex-col">
      {title && (
        <div className="flex flex-col gap-4">
          <p className="text-2xl">{title}</p>
          <div className="w-2/3 border-b border-gray-300"></div>
        </div>
      )}
      <div className="flex flex-col gap-4">
        {params
          .filter(
            // if the swagger defines one of these headers, omit them, because they are always rendered no matter what in this component
            // docs/src/components/AuthHeaders.tsx
            (headerParam) =>
              headerParam.name !== 'X-Auth-Uuid' &&
              headerParam.name !== 'Authorization' &&
              headerParam.name !== 'X-Request-ID'
          )
          .map((param) => {
            if (typeof param === 'object' && param !== null) {
              return (
                <OpenAPISchema
                  key={`${param.name}-${title}`}
                  /*
                   * this is a hack, but it works for now, maybe find a cleaner way to separate the two
                   * The OpenAPISchema is reused to render params as well
                   */
                  field={param as SchemaObjectWithName}
                />
              );
            }
          })}
      </div>
    </div>
  );
};
